// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { StyledModal, StyledTitle, StyledMessage } from './ForgotPasswordSuccessModalStyles';
import { MailIcon } from '@/icons';

interface IForgotPasswordSuccessModal {
  isOpened: boolean;
  onClose: () => void;
}

const ForgotPasswordSuccessModal = ({ isOpened, onClose }: IForgotPasswordSuccessModal) => {
  const { t } = useTranslation(['auth']);

  return (
    <StyledModal open={isOpened} onCancel={onClose} footer={null}>
      <StyledTitle>{t('auth_forgot_password_success_title')}</StyledTitle>
      <StyledMessage>{t('auth_forgot_password_success_message')}</StyledMessage>
      <MailIcon />
    </StyledModal>
  );
};

export default ForgotPasswordSuccessModal;
